"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlanSimpleValidator = function () {
  function PlanSimpleValidator(form, values) {
    _classCallCheck(this, PlanSimpleValidator);

    var props = void 0,
        _jQValidator = void 0;
    // Default Properties
    var defaults = {
      lang: "pt",
      // Element error tag for jQuery.validator
      errorElement: "span",
      // Error class for jQuery.validator
      errorClass: "h-error",
      // Error Placement for jQuery.validator
      errorPlacement: function errorPlacement(error, element) {
        if (element.hasClass("js-field-userType")) {
          $("#userType-error").append(error);
        } else {
          element.after(error);
        }
      },
      // Event submit handler for jQuery.validator
      submitHandler: function submitHandler(form) {
        form.submit();
      },
      // Texts for jQuery.validator error messages
      texts: {
        pt: {
          errors: {
            required: "Campo obrigatório",
            phone: "Telefone inválido",
            email: "E-mail inválido",
            alphabetical: "Apenas caracteres alfabéticos"
          }
        }
      },
      agree: {
        trigger: ".js-trigger-agree",
        target: ".js-target-agree"
      }
    };

    var validMethods = {
      alphabetical: function alphabetical(value) {
        if (value.trim() !== "") {
          var re = new RegExp(/^[A-Za-zÀ-ÿ\u00f1\u00d1\s'-.]+$/g);
          return re.test(value);
        } else {
          return true;
        }
      },
      emailStrict: function emailStrict(value) {
        if (value.trim() !== "") {
          var re = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
          return re.test(value) && value === encodeURI(value);
        } else {
          return true;
        }
      },
      phonePT: function phonePT(value) {
        if (value.trim() !== "") {
          var re = new RegExp("^[9,2][0-9]{8}$");
          return re.test(value);
        }
      },
      cpPT: function cpPT(value) {
        console.log("cp", value);
        var re = new RegExp("^([0-9]{4}-[0-9]{3}|[0-9]{4})$");
        return re.test(value);
      },
      onlyNumbers: function onlyNumbers(value) {
        if (value.trim() !== "") {
          var re = new RegExp(/^\d+$/g);
          return re.test(value);
        } else {
          return true;
        }
      },
      dateEsFormat: function dateEsFormat(value) {
        if (value.trim !== "") {
          console.log;
          var re = new RegExp(/\d{2}\/\d{2}\/\d{4}/);
          return re.test(value);
        }
      },
      ccOrBi: function ccOrBi(value) {
        if (value.trim() !== "") {
          var re = new RegExp(/^[\d]{8}$/g);
          return re.test(value);
        }
      }
    };

    if (typeof form !== "string") {
      console.error("Enter a valid form's selector as first parameter");
    } else {
      //* Get the default properties from plan-validator-defaults.js
      if (Object.assign) {
        props = Object.assign({}, defaults);
      } else {
        //! IE11
        props = this.objAssign({}, defaults);
      }

      //* Get values if they are provided
      if (values) {
        for (var prop in values) {
          props[prop] = values[prop];
        }
      }
    }

    this.form = form;
    this.props = props;
    this.validMethods = validMethods;
    this._jQValidator = _jQValidator;
    this.init();
  }

  _createClass(PlanSimpleValidator, [{
    key: "objAssign",
    value: function objAssign(a, b) {
      var objs = [a, b];
      var result = objs.reduce(function (r, o) {
        Object.keys(o).forEach(function (k) {
          r[k] = o[k];
        });
        return r;
      }, {});
      return result;
    }

    //* Controls the 2 types of "Código Postal" fields block

  }, {
    key: "controlCPBlock",
    value: function controlCPBlock() {
      var that = this;
      console.log("controlling CP block");

      var $form = $(this.form);
      var setCPValue = this.setCPValue;

      $form.find(".js-cp1").on("keyup", function (e) {
        if ($(this).val().length === 4) {
          $form.find(".js-cp2").trigger("focus");
        }
        setCPValue(that);
      });
      $form.find(".js-cp2").on("keyup", function (e) {
        setCPValue(that);
      });
    }

    //* Method for setting an CP valid value

  }, {
    key: "setCPValue",
    value: function setCPValue(that) {
      var $form = $(that.form);
      console.log("$form", $form);
      var val1 = $form.find(".js-cp1").val();
      var val2 = $form.find(".js-cp2").val();
      $form.find(".js-field-postalcode").val(val1 + "-" + val2);
      if ($form.find(".js-field-postalcode").hasClass("error")) {
        $form.find(".js-field-postalcode").valid();
      }
    }
  }, {
    key: "init",
    value: function init() {
      this.initjQValidator();
      this.controlCPBlock();
      this.controlAgreement();
    }
  }, {
    key: "controlAgreement",
    value: function controlAgreement() {
      var $trigger = $(this.props.agree.trigger),
          $input = $(this.props.agree.target);
      $($trigger).on("click", function () {
        if ($trigger.prop("checked")) {
          $input.val("1");
        } else {
          $input.val("0");
        }
      });
    }
  }, {
    key: "initjQValidator",
    value: function initjQValidator() {
      var _this = this;

      var $form = $(this.form);

      var errors = this.props.texts[this.props.lang].errors;

      var errorElement = this.props.errorElement;

      var errorClass = this.props.errorClass;

      var errorPlacement = this.props.errorPlacement;

      var submitHandler = this.props.submitHandler;

      var rules = {
        name: {
          required: true,
          alphabetical: true,
          messages: {
            required: errors.required,
            alphabetical: errors.alphabetical
          }
        },
        email: {
          required: true,
          emailstrict: true,
          email: false,
          messages: {
            required: errors.required,
            emailstrict: errors.email
          }
        }
      };
      // Combining rules if necessary
      var allRules = void 0;
      if (this.props.rules) {
        if (Object.assign) {
          allRules = Object.assign({}, rules, this.props.rules);
        } else {
          //! IE 11
          allRules = this.objAssign({}, rules);
          allRules = this.objAssign(allRules, this.props.rules);
        }
      } else {
        if (Object.assign) {
          allRules = Object.assign({}, rules);
        } else {
          // ! IE 11
          allRules = this.objAssign({}, rules);
        }
      }

      /*  */
      $form.each(function (index, element) {
        var $thisForm = $(element);
        _this._jQValidator = $thisForm.validate({
          errorElement: errorElement,
          errorClass: errorClass,
          errorPlacement: errorPlacement,
          submitHandler: submitHandler
        });
        for (var prop in allRules) {
          var $elemById = $thisForm.find(".js-field-" + prop);
          $elemById.rules("add", allRules[prop]);
        }
      });

      $.validator.addMethod("alphabetical", this.validMethods.alphabetical);
      $.validator.addMethod("emailstrict", this.validMethods.emailStrict);
      $.validator.addMethod("onlynumbers", this.validMethods.onlyNumbers);
      $.validator.addMethod("dateEsFormat", this.validMethods.dateEsFormat);
      $.validator.addMethod("ccOrBi", this.validMethods.ccOrBi);
      $.validator.addMethod("cpPT", this.validMethods.cpPT);
      $.validator.addMethod("phonePT", this.validMethods.phonePT);

      var $fieldPhone = $form.find(".js-field-phone");
    }
  }]);

  return PlanSimpleValidator;
}();